module.exports = __webpack_public_path__ + "static/media/galleryImage08.69207463.jpg";